import React from 'react';
import axios from 'axios';
import './contact.css'

window.recaptchaCallback = function(response){
  window.recaptchaResponse = response;
  // console.log("recaptcha response: "+response);
}

window.recaptchaExpiredCallback = function(response){
  window.recaptchaResponse = null;
  // console.log("recaptcha expired");
}

function validate(name, email, message) {
  
  const errors = {
    name: [],
    email: [],
    message: [],
    count: 0
  };

  if (name.length === 0) {
    errors.name.push("Name can't be empty");
    errors.count++;
  }

  if (email.length < 5) {
    errors.email.push("Email should be at least 5 charcters long");
    errors.count++;
  }
  if (email.split('').filter(x => x === '@').length !== 1) {
    errors.email.push("Email should contain a @");
    errors.count++;
  }
  if (email.indexOf('.') === -1) {
    errors.email.push("Email should contain at least one dot");
    errors.count++;
  }

  if (message.length < 6) {
    errors.message.push("Message must be at least 6 characters long :)");
    errors.count++;
  }

  return errors;
}

function setFieldValidity(field, validationErrors){
  if (validationErrors[field].length > 0){
    let elClass = "hs-contact-"+field
    let el = document.getElementsByClassName(elClass)[0];
    el.classList.add('is-invalid')
  } else {
    let elClass = "hs-contact-"+field
    let el = document.getElementsByClassName(elClass)[0]
    el.classList.remove('is-invalid')
  }
}

function setAllFieldsValidity(validationErrors){
  let fields = ['name', 'email', 'message'];
  
  fields.forEach(field => {
      setFieldValidity(field, validationErrors)
  })
}

function showNotification(message){
	var notification = document.querySelector('.mdl-js-snackbar');
	var data = {
	  message: message,
	  // actionHandler: function(event) {},
	  // actionText: 'Ok',
	  timeout: 3000
	};
	notification.MaterialSnackbar.showSnackbar(data);
}

export class ContactComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      email: '',
      message:'',
      isSendingRequest: false,
      submitted: false,
      touched: {
        name: false,
        email: false,
        message: false
      },
      errors:{
                name: [],
                email: [],
                message: [],
                count: 0
              }
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  
  
  handleChange = (field) => (event) => {
    this.setState({
      [field]: event.target.value,
    });
  
   // redundant but prevents flicker 
   if(this.state.submitted){
      const validationErrors = validate(this.state.name, this.state.email, this.state.message);
      this.setState({ errors: validationErrors});
      setFieldValidity(field, validationErrors)
    }
    
    // state does not update instantly. timeout needed
    setTimeout(t=>{
      if(this.state.submitted){
        const validationErrors = validate(this.state.name, this.state.email, this.state.message);
        this.setState({ errors: validationErrors});
        setFieldValidity(field, validationErrors)
      }
    },100)
    
  }

  handleSubmit(event) {
    event.preventDefault();
    const validationErrors = validate(this.state.name, this.state.email, this.state.message);
    if (validationErrors.count > 0) {
      this.setState({ errors: validationErrors, submitted: true });
      setAllFieldsValidity(validationErrors)
      return;
    } else {
      
      let that = this;
      
     
      if(window.recaptchaResponse || true){
        let message = {
          name: this.state.name,
          email: this.state.email,
          message: this.state.message,
          recaptchaResponse: window.recaptchaResponse
        }
        that.setState({ isSendingRequest: true });
         axios.post('https://us-central1-hue-sync.cloudfunctions.net/app/messages', message)
            .then(function (response) {
              // console.log(response);
              showNotification("Thank you for your message. I will try to answer soonest possible.")
              that.setState({
                      name: '',
                      email: '',
                      message:'',
                      submitted: false,
                      isSendingRequest: false,
                      touched: {
                        name: false,
                        email: false,
                        message: false
                      },
                      errors:{
                                name: [],
                                email: [],
                                message: [],
                                count: 0
                              }
                    });
            })
            .catch(function (error) {
              // console.log(error);
              that.setState({ isSendingRequest: false });
              showNotification("An error has occured. Please try again later.")
          });
      } else {
        showNotification("Please check Recaptcha!")
      }
    }
  }
  
  handleBlur = (field) => (event) => {
    this.setState({
      touched: { ...this.state.touched, [field]: true },
    });
  }
  
  render() {
    return <div className="section hs-contact-section">
              <form action="#"
                    
                    className="hs-contact-form layout-column layout-align-center-center"
                    onSubmit={this.handleSubmit}>
                  <div className="mdl-textfield mdl-js-textfield mdl-textfield--floating-label hs-contact-name">
                    <input className="mdl-textfield__input hs-input" type="text" id="name"
                            value={this.state.name} onChange={this.handleChange('name')}
                            onBlur={this.handleBlur('name')}></input>
                    <label className="mdl-textfield__label hs-input-label" for="name">Name</label>
                    <span class="mdl-textfield__error">{this.state.errors.name[0]}</span>
                  </div>
                  <div className="mdl-textfield mdl-js-textfield mdl-textfield--floating-label hs-contact-email">
                    <input className="mdl-textfield__input hs-input"
                            type="text" id="email"
                            value={this.state.email} onChange={this.handleChange('email')}
                            onBlur={this.handleBlur('email')}></input>
                    <label className="mdl-textfield__label hs-input-label" for="email">Email</label>
                    <span class="mdl-textfield__error">{this.state.errors.email[0]}</span>
                  </div>
                  <div className="mdl-textfield mdl-js-textfield mdl-textfield--floating-label hs-contact-message">
                    <textarea className="mdl-textfield__input hs-input" type="text" rows= "8" id="message"
                            value={this.state.message} onChange={this.handleChange('message')}
                            onBlur={this.handleBlur('message')}></textarea>
                    <label className="mdl-textfield__label hs-input-label" for="message">Message</label>
                    <span class="mdl-textfield__error">{this.state.errors.message[0]}</span>
                  </div>
                  <div className="g-recaptcha" data-sitekey="6LekrHIUAAAAADo2x2Gx4U_S_o0UX2KNw1CmC-bP" 
                        data-callback="recaptchaCallback"
                        data-expired-callback="recaptchaExpiredCallback"
                        data-theme="dark"></div>
                  <button className={"mdl-button mdl-js-button mdl-button--raised mdl-button--colored hs-contact-button "+ (this.state.isSendingRequest == true ? 'hidden':'')} onClick={this.handleSendClick}>
                    Send
                  </button>
              </form>
              <div className={"mdl-spinner mdl-spinner--single-color mdl-js-spinner hs-contact-spinner is-active "+ (this.state.isSendingRequest == false ? 'hidden':'')}></div>
            </div>
  }
}


// WEBPACK FOOTER //
// ./src/components/contact.js